<template>
  <section v-if="quotationInfo">
    <validation-observer ref="requestSubmit">
      <b-row class="px-2">
        <b-col cols="12" lg="12" class="pt-1"
          ><h4>Customs declaration information</h4></b-col
        >
        <b-col cols="12" lg="6">
          <b-form-group>
            <label>Customs type</label>
            <Select2
              :disabled="readonly"
              placeholder="Customs type"
              v-model="quotationInfo.customs_type"
              :options="customs_types"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12" lg="6">
          <validation-provider
            name="Business type"
            #default="{ errors }"
            rules="required"
          >
            <b-form-group>
              <label>Business type<font class="red">*</font></label>
              <Select2
                :class="errors.length > 0 ? 'is-invalid' : null"
                :disabled="readonly"
                placeholder="Business type"
                v-model="quotationInfo.business_type"
                :options="business_types"
              />
              <small class="text-danger" v-show="errors.length > 0">{{
                errors[0]
              }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="12" lg="6">
          <validation-provider
            name="Place of Custom declaration"
            #default="{ errors }"
            rules="required"
          >
            <b-form-group>
              <label
                >Place of Custom declaration<font class="red">*</font></label
              >
              <b-form-input
                :state="errors.length > 0 ? false : null"
                :disabled="readonly"
                v-model="quotationInfo.customs_addr"
                placeholder="Place of Custom declaration"
              />
              <small class="text-danger" v-show="errors.length > 0">{{
                errors[0]
              }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="12" lg="6">
          <b-form-group>
            <label>HS Code</label>
            <b-form-input
              :disabled="readonly"
              v-model="quotationInfo.hs_code"
              placeholder="HS Code"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12"><h4>Cargo Information</h4></b-col>
        <b-col cols="12">
          <b-row>
            <b-col
              cols="12"
              :lg="
                quotationInfo.customs_other_service_type == 'VAN' ||
                quotationInfo.customs_other_service_type == 'CONTAINER'
                  ? 4
                  : 6
              "
            >
              <validation-provider
                name="Commodity"
                #default="{ errors }"
                rules="required"
              >
                <b-form-group>
                  <label>Commodity<font class="red">*</font></label>
                  <Select2
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    :disabled="readonly"
                    placeholder="Commodity"
                    v-model="quotationInfo.goods_type"
                    :options="goods_types"
                  />
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col
              cols="12"
              :lg="
                quotationInfo.customs_other_service_type == 'VAN' ||
                quotationInfo.customs_other_service_type == 'CONTAINER'
                  ? 4
                  : 6
              "
            >
              <validation-provider
                name="Commodity description"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Commodity description</label>
                  <b-form-input
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonly"
                    v-model="quotationInfo.mo_ta"
                    placeholder="Commodity description"
                  />
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col
              cols="12"
              lg="4"
              v-if="
                quotationInfo.customs_other_service_type == 'VAN' ||
                quotationInfo.customs_other_service_type == 'CONTAINER'
              "
            >
              <validation-provider
                name="Gross Weight (kgs)"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Total Gross Weight (kg)</label>
                  <cleave
                    :state="errors.length > 0 ? false : null"
                    :options="$Utils.CONSTANTS.cleaveNumeral"
                    :disabled="readonly"
                    v-model="quotationInfo.trong_luong"
                    class="form-control"
                    placeholder="Gross Weight (kgs)"
                  />
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <!-- <b-col cols="12" lg="4">
              <b-form-group>
                <label>Volume (Monthly)</label>
                <Select2
                  :disabled="readonly"
                  placeholder="Volume (Monthly)"
                  v-model="quotationInfo.volume"
                  :options="$Utils.CONSTANTS.VOLUMES"
                />
              </b-form-group>
            </b-col> -->
          </b-row>
        </b-col>

        <b-col
          cols="12"
          lg="4"
          v-if="quotationInfo.customs_other_service_type == 'VAN'"
        >
          <b-form-group>
            <label>Measurement (cbm)</label>
            <cleave
              :options="$Utils.CONSTANTS.cleaveNumeral"
              :disabled="readonly"
              v-model="quotationInfo.so_khoi"
              class="form-control"
              placeholder="Measurement (kgs)"
            />
            <!-- <b-form-input
                  type="number"
                  :disabled="readonly"
                  v-model="quotationInfo.so_khoi"
                  placeholder="Measurement (kgs)"
                /> -->
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          lg="4"
          v-if="quotationInfo.customs_other_service_type == 'VAN'"
        >
          <validation-provider
            name="Package Type"
            #default="{ errors }"
            rules=""
          >
            <b-form-group>
              <label>Package Type </label>
              <Select2
                :class="errors.length > 0 ? 'is-invalid' : null"
                :disabled="readonly"
                placeholder="Package type"
                v-model="quotationInfo.package_type"
                :options="cont_types.filter((i) => i.group === 'packaging')"
              />
              <small class="text-danger" v-show="errors.length > 0">{{
                errors[0]
              }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col
          cols="12"
          lg="4"
          v-if="quotationInfo.customs_other_service_type == 'VAN'"
        >
          <validation-provider
            name="Package Number"
            #default="{ errors }"
            rules=""
          >
            <b-form-group>
              <label>Package Number</label>
              <b-form-input
                :state="errors.length > 0 ? false : null"
                :disabled="readonly"
                v-model="quotationInfo.packageNumber"
                placeholder="Package Number"
              />
            </b-form-group>
          </validation-provider>
        </b-col>

        <b-col
          v-if="quotationInfo.customs_other_service_type == 'CONTAINER'"
          cols="12"
          class="pt-1"
          ><h4>Freight Informations</h4></b-col
        >
        <b-col
          v-if="quotationInfo.customs_other_service_type == 'CONTAINER'"
          cols="12"
        >
          <validation-provider name="Carrier" #default="{ errors }" rules="">
            <b-form-group>
              <label>Carrier</label>
           
              <Select4
                v-model="quotationInfo.shipping_line"
                :class="[
                  errors.length > 0 ? 'is-invalid' : null,
                  readonly == true ? 'remove' : '',
                ]"
                placeholder="Carrier"
                :disabled="readonly"
                :options="{
                  value: 'id',
                  label: 'text',
                  data: shipping_lines,
                  fields: [
                    { field: 'code', label: 'Code' },
                    { field: 'name', label: 'Shipping Line' },
                  ],
                }"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>

        <b-col cols="12">
          <div v-if="quotationInfo.customs_other_service_type == 'CONTAINER'">
            <b-row>
              <b-col cols="12"><h4>Shipment Informations</h4></b-col>
            </b-row>
            <b-row
              v-if="quotationInfo.customs_other_service_type == 'CONTAINER'"
            >
              <b-col cols="12" lg="6">
                <b-form-group>
                  <label>Booking/HBL/INV</label>
                  <b-form-input
                    :disabled="readonly"
                    placeholder="Booking/HBL/INV"
                    v-model="quotationInfo.HBL"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12" lg="6">
                <b-form-group>
                  <label>Shipping Type</label>
                  <Select2
                    :disabled="readonly"
                    placeholder="Shipping Type"
                    v-model="quotationInfo.shippingType"
                    :options="
                      quotationInfo.service_type == 5
                        ? transport_types.filter((i) =>
                            [1, 2, 3, 4].includes(i.id)
                          )
                        : quotationInfo.service_type == 6
                        ? transport_types.filter((i) =>
                            [1, 2, 3, 4].includes(i.id)
                          )
                        : transport_types.filter((i) => [1, 2].includes(i.id))
                    "
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" lg="6">
                <validation-provider
                  name="Container Type"
                  #default="{ errors }"
                  rules=""
                >
                  <b-form-group>
                    <label>Container Type</label>
                    <Select2
                      :class="errors.length > 0 ? 'is-invalid' : null"
                      :disabled="readonly"
                      placeholder="Container Type"
                      v-model="quotationInfo.cont_type"
                      :options="
                        cont_types.filter((i) => i.group === 'Container truck')
                      "
                    />
                    <small class="text-danger" v-show="errors.length > 0">{{
                      errors[0]
                    }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col cols="12" lg="6">
                <validation-provider
                  name="Quantity"
                  #default="{ errors }"
                  rules=""
                >
                  <b-form-group>
                    <label>Quantity</label>
                    <b-form-input
                      placeholder="Quantity"
                      type="number"
                      :state="errors.length > 0 ? false : null"
                      :disabled="readonly"
                      v-model="quotationInfo.so_luong"
                    />
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" lg="6">
                <validation-provider
                  name="Container No."
                  #default="{ errors }"
                  rules=""
                >
                  <b-form-group>
                    <label>Container No.</label>
                    <b-form-input
                      :state="errors.length > 0 ? false : null"
                      :disabled="readonly"
                      v-model="quotationInfo.container_no"
                      placeholder="Quantity"
                    />
                    <small class="text-danger" v-show="errors.length > 0">{{
                      errors[0]
                    }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12" lg="6">
                <validation-provider
                  name="Seal No."
                  #default="{ errors }"
                  rules=""
                >
                  <b-form-group>
                    <label>Seal No.</label>
                    <b-form-input
                      :state="errors.length > 0 ? false : null"
                      :disabled="readonly"
                      v-model="quotationInfo.seal"
                      placeholder="Quantity"
                    />
                    <small class="text-danger" v-show="errors.length > 0">{{
                      errors[0]
                    }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" lg="4">
                <validation-provider
                  name="Pick up"
                  #default="{ errors }"
                  rules="required"
                >
                  <b-form-group>
                    <label>Pick up<font class="red">*</font></label>
                    <div class="d-flex align-items-center">
                      <Select4
                  v-model="quotationInfo.pickup_location"
                  v-if="!quotationInfo.isHideShows"
                  :classProp="errors.length > 0 ? 'is-invalid' : null"
                  placeholder="Pick up"
                  :disabled="readonly"
                  :options="{
                    value: 'id',
                    label: 'text',
                    data: pickupFilter,
                    fields: [
                      { field: 'abbreviations', label: 'Abbreviations' },
                      { field: 'name', label: 'Location' },
                      {
                        field: 'address',
                        label: 'Address',
                      },
                    ],
                  }"
                />
               
                      <b-form-input
                        v-if="quotationInfo.isHideShows"
                        :state="errors.length > 0 ? false : null"
                        :disabled="readonly"
                        v-model="quotationInfo.other_pickup_location"
                        placeholder="Enter pick up "
                      />
                      <b-form-checkbox
                        :disabled="readonly"
                        v-on:change="hideShows"
                        v-model="quotationInfo.isHideShows"
                        class="check_input"
                        >Other
                      </b-form-checkbox>
                    </div>
                    <small class="text-danger" v-show="errors.length > 0">{{
                      errors[0]
                    }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12" lg="4">
                <validation-provider
                  name="Delivery"
                  #default="{ errors }"
                  rules="required"
                >
                  <b-form-group>
                    <label>Delivery<font class="red">*</font></label>
                    <div class="d-flex align-items-center">
                      <Select4
                  v-model="quotationInfo.delivery_location"
                  v-if="!quotationInfo.isHideShowPk"
                  :classProp="errors.length > 0 ? 'is-invalid' : null"
                  placeholder="Delivery"
                  :disabled="readonly"
                  :options="{
                    value: 'id',
                    label: 'text',
                    data: deliveryFilter,
                    fields: [
                      { field: 'abbreviations', label: 'Abbreviations' },
                      { field: 'name', label: 'Location' },
                      {
                        field: 'address',
                        label: 'Address',
                      },
                    ],
                  }"
                />
                      <b-form-input
                        v-if="quotationInfo.isHideShowPk"
                        :state="errors.length > 0 ? false : null"
                        :disabled="readonly"
                        v-model="quotationInfo.other_delivery_location"
                        placeholder="Enter delivery"
                      />
                      <b-form-checkbox
                        :disabled="readonly"
                        v-on:change="hideShowsPk"
                        v-model="quotationInfo.isHideShowPk"
                        class="check_input"
                        >Other
                      </b-form-checkbox>
                    </div>
                    <small class="text-danger" v-show="errors.length > 0">{{
                      errors[0]
                    }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col cols="12" lg="4">
                <b-form-group>
                  <label>Empty depot<font class="red">*</font></label>
                
                  <Select4
                  v-model="quotationInfo.deport_location"
                  placeholder="Empty depot"
                  :disabled="readonly"
                  :options="{
                    value: 'id',
                    label: 'text',
                    data: deports_locations,
                    fields: [
                      { field: 'abbreviations', label: 'Abbreviations' },
                      { field: 'name', label: 'Location' },
                      {
                        field: 'address',
                        label: 'Address',
                      },
                    ],
                  }"
                />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row
              v-if="quotationInfo.customs_other_service_type == 'CONTAINER'"
            >
              <b-col cols="12" lg="4">
                <validation-provider
                  name="PIC pick up"
                  #default="{ errors }"
                  rules=""
                >
                  <b-form-group>
                    <label>Pick up date</label>

                    <section>
                      <date-picker
                        ref="datePicker"
                        v-model="quotationInfo.pick_up_date"
                        type="datetime"
                        class="w-full"
                        :disabled="readonly"
                        value-type="format"
                        title-format="DD-MM-YYYY"
                        :state="errors.length > 0 ? false : null"
                        time-title-format="DD-MM-YYYY"
                        placeholder="Select datetime"
                        :show-time-panel="showTimePanel"
                        format="DD-MM-YYYY HH:mm"
                        @close="handleOpenChange"
                      >
                        <template v-slot:footer>
                          <button
                            class="mx-btn mx-btn-text"
                            @click="toggleTimePanel"
                          >
                            {{ showTimePanel ? "Date" : "Time" }}
                          </button>
                        </template>
                      </date-picker>
                    </section>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12" lg="4">
                <validation-provider
                  name="PIC pick up"
                  #default="{ errors }"
                  rules=""
                >
                  <b-form-group>
                    <label>Delivery Date</label>

                    <section>
                      <date-picker
                        ref="datePicker"
                        v-model="quotationInfo.delivery_date"
                        :disabled-date="disabledRangeDelivery"
                        type="datetime"
                        class="w-full"
                        value-type="format"
                        :state="errors.length > 0 ? false : null"
                        :disabled="readonly"
                        title-format="DD-MM-YYYY"
                        time-title-format="DD-MM-YYYY"
                        placeholder="Select datetime"
                        :show-time-panel="showTimePanel"
                        format="DD-MM-YYYY HH:mm"
                        @close="handleOpenChange"
                      >
                        <template v-slot:footer>
                          <button
                            class="mx-btn mx-btn-text"
                            @click="toggleTimePanel"
                          >
                            {{ showTimePanel ? "Date" : "Time" }}
                          </button>
                        </template>
                      </date-picker>
                    </section>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12" lg="4">
                <b-form-group>
                  <label>Cut off Date</label>

                  <section>
                    <date-picker
                      ref="datePicker"
                      v-model="quotationInfo.cutOffDate"
                      type="datetime"
                      class="w-full"
                      :disabled="readonly"
                      value-type="format"
                      title-format="DD-MM-YYYY"
                      time-title-format="DD-MM-YYYY"
                      placeholder="Select datetime"
                      :show-time-panel="showTimePanel"
                      format="DD-MM-YYYY HH:mm"
                      @close="handleOpenChange"
                    >
                      <template v-slot:footer>
                        <button
                          class="mx-btn mx-btn-text"
                          @click="toggleTimePanel"
                        >
                          {{ showTimePanel ? "Date" : "Time" }}
                        </button>
                      </template>
                    </date-picker>
                  </section>
                </b-form-group>
              </b-col>
              <b-col cols="12" lg="6">
                <validation-provider
                  name="PIC pick up"
                  #default="{ errors }"
                  rules=""
                >
                  <b-form-group>
                    <label>PIC pick up</label>
                    <b-form-input
                      placeholder="PIC pick up"
                      :state="errors.length > 0 ? false : null"
                      :disabled="readonly"
                      v-model="quotationInfo.PICPickUp"
                    />
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12" lg="6">
                <validation-provider
                  name="PIC Delivery"
                  #default="{ errors }"
                  rules=""
                >
                  <b-form-group>
                    <label>PIC Delivery</label>
                    <b-form-input
                      placeholder="PIC Delivery"
                      :state="errors.length > 0 ? false : null"
                      :disabled="readonly"
                      v-model="quotationInfo.PICDelivery"
                    />
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
          </div>
        </b-col>

        <b-col
          v-if="quotationInfo.customs_other_service_type == 'VAN'"
          cols="12"
          ><h4>Shipment Informations</h4></b-col
        >

        <b-col
          cols="12"
          lg="6"
          v-if="quotationInfo.customs_other_service_type == 'VAN'"
        >
          <b-form-group>
            <label>Booking/HBL/INV</label>
            <b-form-input
              :disabled="readonly"
              placeholder="Booking/HBL/INV"
              v-model="quotationInfo.HBL"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          lg="6"
          v-if="quotationInfo.customs_other_service_type == 'VAN'"
        >
          <b-form-group>
            <label>Shipping Type</label>
            <Select2
              :disabled="readonly"
              placeholder="Shipping Type"
              v-model="quotationInfo.shippingType"
              :options="
                quotationInfo.service_type == 5
                  ? transport_types.filter((i) => [1, 2, 3, 4].includes(i.id))
                  : quotationInfo.service_type == 6
                  ? transport_types.filter((i) => [1, 2, 3, 4].includes(i.id))
                  : transport_types.filter((i) => [1, 2].includes(i.id))
              "
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          lg="6"
          v-if="quotationInfo.customs_other_service_type == 'VAN'"
        >
          <validation-provider name="Truck Type" #default="{ errors }" rules="">
            <b-form-group>
              <label>Truck Type</label>
              <Select2
                :class="errors.length > 0 ? 'is-invalid' : null"
                :disabled="readonly"
                placeholder="Truck Type"
                v-model="quotationInfo.truck_type"
                :options="cont_types.filter((i) => i.group === 'van truck')"
              />
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col
          cols="12"
          lg="6"
          v-if="quotationInfo.customs_other_service_type == 'VAN'"
        >
          <validation-provider name="Quantity" #default="{ errors }" rules="">
            <b-form-group>
              <label>Quantity</label>
              <b-form-input
                placeholder="Quantity"
                type="number"
                :state="errors.length > 0 ? false : null"
                :disabled="readonly"
                v-model="quotationInfo.so_luong"
              />
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col
          v-if="quotationInfo.customs_other_service_type == 'VAN'"
          cols="12"
          lg="6"
        >
          <validation-provider
            name="Pick up"
            #default="{ errors }"
            rules="required"
          >
            <b-form-group>
              <label>Pick up<font class="red">*</font></label>
              <div class="d-flex align-items-center">
                <Select2
                  :class="errors.length > 0 ? 'is-invalid' : null"
                  class="hide_select"
                  :disabled="readonly"
                  v-if="!quotationInfo.isHideShows"
                  placeholder="Pick up"
                  v-model="quotationInfo.pickup_location"
                  :options="pickupFilter"
                />
                <b-form-input
                  v-if="quotationInfo.isHideShows"
                  :state="errors.length > 0 ? false : null"
                  :disabled="readonly"
                  v-model="quotationInfo.other_pickup_location"
                  placeholder="Enter pick up "
                />
                <b-form-checkbox
                  :disabled="readonly"
                  v-on:change="hideShows"
                  v-model="quotationInfo.isHideShows"
                  class="check_input"
                  >Other
                </b-form-checkbox>
              </div>
              <small class="text-danger" v-show="errors.length > 0">{{
                errors[0]
              }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col
          v-if="quotationInfo.customs_other_service_type == 'VAN'"
          cols="12"
          lg="6"
        >
          <validation-provider
            name="Delivery"
            #default="{ errors }"
            rules="required"
          >
            <b-form-group>
              <label>Delivery<font class="red">*</font></label>
              <div class="d-flex align-items-center">
                <Select2
                  :class="errors.length > 0 ? 'is-invalid' : null"
                  class="hide_select"
                  v-if="!quotationInfo.isHideShowPk"
                  :disabled="readonly"
                  placeholder="Delivery"
                  v-model="quotationInfo.delivery_location"
                  :options="deliveryFilter"
                />
                <b-form-input
                  v-if="quotationInfo.isHideShowPk"
                  :state="errors.length > 0 ? false : null"
                  :disabled="readonly"
                  v-model="quotationInfo.other_delivery_location"
                  placeholder="Enter delivery"
                />
                <b-form-checkbox
                  :disabled="readonly"
                  v-on:change="hideShowsPk"
                  v-model="quotationInfo.isHideShowPk"
                  class="check_input"
                  >Other
                </b-form-checkbox>
              </div>
              <small class="text-danger" v-show="errors.length > 0">{{
                errors[0]
              }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col
          cols="12"
          lg="6"
          v-if="quotationInfo.customs_other_service_type == 'VAN'"
        >
          <b-form-group>
            <label>Pick up date</label>

            <section>
              <date-picker
                ref="datePicker"
                v-model="quotationInfo.pick_up_date"
                type="datetime"
                class="w-full"
                :disabled="readonly"
                value-type="format"
                title-format="DD-MM-YYYY"
                time-title-format="DD-MM-YYYY"
                placeholder="Select datetime"
                :show-time-panel="showTimePanel"
                format="DD-MM-YYYY HH:mm"
                @close="handleOpenChange"
              >
                <template v-slot:footer>
                  <button class="mx-btn mx-btn-text" @click="toggleTimePanel">
                    {{ showTimePanel ? "Date" : "Time" }}
                  </button>
                </template>
              </date-picker>
            </section>
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          lg="6"
          v-if="quotationInfo.customs_other_service_type == 'VAN'"
        >
          <b-form-group>
            <label>Delivery Date</label>

            <section>
              <date-picker
                ref="datePicker"
                v-model="quotationInfo.delivery_date"
                :disabled-date="disabledRangeDelivery"
                type="datetime"
                class="w-full"
                value-type="format"
                :disabled="readonly"
                title-format="DD-MM-YYYY"
                time-title-format="DD-MM-YYYY"
                placeholder="Select datetime"
                :show-time-panel="showTimePanel"
                format="DD-MM-YYYY HH:mm"
                @close="handleOpenChange"
              >
                <template v-slot:footer>
                  <button class="mx-btn mx-btn-text" @click="toggleTimePanel">
                    {{ showTimePanel ? "Date" : "Time" }}
                  </button>
                </template>
              </date-picker>
            </section>
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          lg="6"
          v-if="quotationInfo.customs_other_service_type == 'VAN'"
        >
          <validation-provider
            name="PIC pick up"
            #default="{ errors }"
            rules=""
          >
            <b-form-group>
              <label>PIC pick up</label>
              <b-form-input
                placeholder="PIC pick up"
                :state="errors.length > 0 ? false : null"
                :disabled="readonly"
                v-model="quotationInfo.PICPickUp"
              />
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col
          cols="12"
          lg="6"
          v-if="quotationInfo.customs_other_service_type == 'VAN'"
        >
          <validation-provider
            name="PIC Delivery"
            #default="{ errors }"
            rules=""
          >
            <b-form-group>
              <label>PIC Delivery</label>
              <b-form-input
                placeholder="PIC Delivery"
                :state="errors.length > 0 ? false : null"
                :disabled="readonly"
                v-model="quotationInfo.PICDelivery"
              />
            </b-form-group>
          </validation-provider>
        </b-col>
        <!-- end custom -->
        <b-col cols="12">
          <b-form-group>
            <label>Notes</label>
            <b-form-textarea
              rows="5"
              :disabled="readonly"
              v-model="quotationInfo.notes"
              placeholder="Notes"
            />
          </b-form-group>
        </b-col>

        <b-col
          cols="12"
          v-if="quotationInfo.customs_other_service_type == 'CONTAINER'"
        >
          <b-form-group>
            <label>Billing information</label>
            <b-form-textarea
              :disabled="readonly"
              v-model="request_quotation.billingInformation"
              placeholder="Billing information"
            />
          </b-form-group>
        </b-col>
        <!-- <b-col cols="12">
          <b-form-group>
            <label>Notes2</label>
            <b-form-textarea
              rows="5"
              :disabled="readonly"
              v-model="quotationInfo.note2"
              placeholder="Notes"
            />
          </b-form-group>
        </b-col> -->
      </b-row>
    </validation-observer>
    <AttachFile class="px-2" :quotationInfo.sync="quotationInfo" />
  </section>
</template>

<script>
import useJwt from "@/auth/jwt/useJwt";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import Select2 from "v-select2-component";
import moment from "moment";
import AttachFile from "./components/AttachFile.vue";
import { mapState, mapActions } from "vuex";
import mixins from "./mixin/mixin";
export default {
  mixins: [mixins],

  props: ["request_quotation"],
  components: {
    AttachFile,
    ValidationProvider,
    Select2,
    ValidationObserver,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("userData")),
      showTimePanel: false,
      showTimeRangePanel: false,
      isHideShow: false,
      isHideShowPk: false,
      maxFiles: false,
      isHideShowBookingEdit: false,
      isHideShowPkBookingEdit: false,
      readonly: false,
      cut_off: "",
      quotationInfo: {
        pick_up_date: null,
        delivery_date: null,
      },
      useLocations: [],
      moment,
    };
  },
  watch: {
    cut_off(n) {
      this.$emit("cut-off", n);
    },
  },

  computed: {
    ...mapState("masterData", [
      "locations",
      "ports",
      "cont_types",
      "goods_types",
      "transport_types",
      "regions",
      "deports_locations",
      "business_types",
      "customs_types",
      "incoterms",
      "regions",
      "deports",
      "shipping_lines",
    ]),
    isVolume() {
      return (
        this.quotationInfo.has_container_trucking ||
        this.quotationInfo.has_customs
      );
    },
   
  },
  created() {
    this.$loading.show();
    this.quotationInfo = {};
    this.getLocation();

    this.quotationInfo.id = this.request_quotation.bookingID;

    this.quotationInfo.files = this.request_quotation.files;

    this.quotationInfo.customs_other_service_type =
      this.request_quotation.customs_other_service_type;

    this.quotationInfo.id = this.request_quotation.bookingID;

    this.quotationInfo.service_type = this.request_quotation.service_type;

    this.quotationInfo.customs_type = this.request_quotation.customs_type;

    this.quotationInfo.business_type = this.request_quotation.business_type;

    this.quotationInfo.customs_addr = this.request_quotation.customs_addr;

    this.quotationInfo.hs_code = this.request_quotation.hs_code;

    this.quotationInfo.package_type = this.request_quotation.package_type;

    this.quotationInfo.goods_type = this.request_quotation.goods_type;

    this.quotationInfo.mo_ta = this.request_quotation.mo_ta;

    this.quotationInfo.volume = this.request_quotation.volume;
    this.quotationInfo.cont_type = this.request_quotation.cont_type;

    this.quotationInfo.notes = this.request_quotation.notes;

    this.quotationInfo.so_luong = this.request_quotation.so_luong;

    this.quotationInfo.note2 = this.request_quotation.note2;

    this.quotationInfo.HBL = this.request_quotation.HBL;
    this.quotationInfo.shippingType = this.request_quotation.shippingType;
  },
  mounted() {},
  methods: {
    disabledRangeDelivery: function (date) {
      if (this.quotationInfo.pick_up_date) {
        var mydate = moment(this.quotationInfo.pick_up_date, "DD/MM/YYYY");

        //format that date into a different format
        var now = moment(mydate).format("MM/DD/YYYY");

        return date < new Date(now);
      }
    },
    toggleTimePanel() {
      this.showTimePanel = !this.showTimePanel;
    },
    toggleTimeRangePanel() {
      this.showTimeRangePanel = !this.showTimeRangePanel;
    },
    handleCloseChange() {
      this.$refs.datePicker.popupVisible = false;
    },
    handleOpenChange() {
      this.showTimePanel = false;
    },
    handleRangeClose() {
      this.showTimeRangePanel = false;
    },
    hideShows: function () {
      this.isHideShow = !this.isHideShow;
    },
    hideShowsPk: function () {
      this.isHideShowPk = !this.isHideShowPk;
    },
    changeHideShows: function () {
      this.isHideShowBookingEdit = !this.isHideShowBookingEdit;
    },
    changeHideShowsPk: function () {
      this.isHideShowPkBookingEdit = !this.isHideShowPkBookingEdit;
    },
  },
};
</script>

<style>
</style>